import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { PositionedOverlay } from 'reaxl';
import KBBDealIndicator from '../KBBDealIndicator/index.js';

/**
 *  molecule to encapsulate standard PositionOverlay + KBBDealIndicator logic
 *
 */
function KBBDealIndicatorOverlay(_ref) {
  let {
    className,
    position = 'topRight',
    children,
    offsetTop = 50,
    pricingDetail,
    ...rest
  } = _ref;
  const props = {
    pricingDetail,
    position
  };
  return /*#__PURE__*/React.createElement(PositionedOverlay, Object.assign({
    className: className,
    shrinkwrap: false
  }, rest), /*#__PURE__*/_jsx(PositionedOverlay.Base, {}, void 0, children), /*#__PURE__*/_jsx(PositionedOverlay.Anchor, {
    position: position,
    offsetTop: offsetTop
  }, void 0, /*#__PURE__*/React.createElement(KBBDealIndicator, props)));
}
export default KBBDealIndicatorOverlay;